import React, { useEffect, useState } from "react";
import "../../../css/page-profile.css";
import { useAuth } from "../../Context/store/context";
import globals from '../../../globals';
import MyQRCode from "../Dashboard/MyQrCode";
import { useDispatch, useSelector } from "react-redux";
import { domainsList } from '../../Redux/Actions/DomainsListAction';
import { _get } from "../../../apiClient";
import { _showToast } from "../../../toastHelper";



export default function MyOneQr() {
  const domains = useSelector((state) => state.DomainsList.domainsList);
  const userDetails = useSelector((state) => state.admininfo.admininfo);

  const { showLoader, hideLoader, updateTitleAndIcon, getToken, logoutuser } = useAuth();
  const dispatch = useDispatch();
  const [isInitialLoading, setInitialLoading] = useState(true);
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.myoneqr.title, globals.myoneqr.icon);
  }, []);

  useEffect(() => {
    if (userDetails && isInitialLoading && domains.length == 0) {
      fetchDomains();
    }
    else {
      if (domains.length > 0)
        setUrl(domains?.filter(x => x.isPrimary == true)[0].domainName ?? '');
    }
  }, [domains, userDetails]);

  const fetchDomains = async () => {
    showLoader();
    setInitialLoading(false);
    await _get('/app-user-domains')
      .then((response) => {
        dispatch(domainsList(response));
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  }

  return (
    <>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <MyQRCode url={url} />
        </div>
      </div >

    </>
  )
}
